export default "__VITE_ASSET__Bqius4px__"